import React from 'react';
import { motion } from 'framer-motion';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { whyChooseData } from '../data';

const WhyChoose = () => {
  const [ref, isVisible] = useScrollAnimation();

  return (
    <section className="section-padding" ref={ref}>
      <div className="container-custom">
        <div className="text-center mb-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={isVisible ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
          >
            <span className="section-badge">Why Choose Us</span>
            <h2 className="heading-primary mt-4">
              Building Excellence,{' '}
              <span className="text-gradient">Ensuring Safety</span>
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto mt-4">
              Our core values reflect a commitment to integrity, quality, safety, 
              and innovation in every project we undertake.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {whyChooseData.map((item, index) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 30 }}
              animate={isVisible ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="card-hover bg-white rounded-2xl p-6 text-center shadow-soft border border-gray-100"
            >
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${item.icon} text-2xl text-primary`}></i>
              </div>
              <h3 className="text-xl font-bold text-secondary font-oswald mb-2">
                {item.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;